(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
class CustomSlideshow extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = this.querySelectorAll('.custom-slideshow__slide');
    this.dots = this.querySelectorAll('.custom-slideshow__dot');
    this.prevBtn = this.querySelector('.custom-slideshow__prev');
    this.nextBtn = this.querySelector('.custom-slideshow__next');
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed) || 5) * 1000;
    this.timer = null;
  }


  connectedCallback() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.move(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.move(1));
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index)));
    });
    if (this.autoplay && this.slides.length > 1) this.startAutoplay();
  }


  move(direction) {
    const next = (this.currentIndex + direction + this.slides.length) % this.slides.length;
    this.goTo(next);
  }


  goTo(index) {
    this.slides[this.currentIndex].classList.remove('is-active');
    if (this.dots[this.currentIndex]) this.dots[this.currentIndex].classList.remove('is-active');
    this.currentIndex = index;
    this.slides[this.currentIndex].classList.add('is-active');
    if (this.dots[this.currentIndex]) this.dots[this.currentIndex].classList.add('is-active');
    if (this.autoplay) {
      clearInterval(this.timer);
      this.startAutoplay();
    }
  }


  startAutoplay() {
    this.timer = setInterval(() => this.move(1), this.speed);
  }
}


customElements.define('custom-slideshow', CustomSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-pickup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('amoria-event-pickup')) {
  customElements.define('amoria-event-pickup', class extends HTMLElement {
    connectedCallback() {
      this.more = this.querySelector('.aep__more');
      this.expand = () => {
        this.classList.add('is-expanded');
        if (this.more) {
          this.more.setAttribute('aria-expanded', 'true');
          this.more.hidden = true;
        }
      };
      this.selectBlock = (event) => {
        if (!this.contains(event.target)) return;
        this.expand();
        const card = event.target.closest('.aep__card');
        if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      };
      if (this.more) {
        this.more.hidden = false;
        this.more.addEventListener('click', this.expand);
      }
      document.addEventListener('shopify:block:select', this.selectBlock);
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      if (this.more) this.more.removeEventListener('click', this.expand);
      document.removeEventListener('shopify:block:select', this.selectBlock);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  class FeaturedCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.itemsPerView = 4;
      this.gap = 16;
    }

    connectedCallback() {
      this.track = this.querySelector('.featured-carousel-track');
      this.items = Array.from(this.querySelectorAll('.featured-carousel-item'));

      const wrapper = this.closest('.featured-carousel-wrapper');
      this.prevBtn = wrapper ? wrapper.querySelector('.featured-carousel-btn--prev') : null;
      this.nextBtn = wrapper ? wrapper.querySelector('.featured-carousel-btn--next') : null;

      if (!this.track || this.items.length === 0) return;

      this.currentIndex = 0;
      this.track.style.transform = 'translateX(0px)';

      this.updateItemsPerView();
      this.updateButtons();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      window.addEventListener('resize', () => {
        this.updateItemsPerView();
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex());
        this.setPosition();
        this.updateButtons();
      });

      // パネル設定
      const sectionEl = this.closest('[id^="section-"]');
      const sectionId = sectionEl ? sectionEl.id.replace('section-', '') : '';
      this.overlay = document.getElementById('fc-overlay-' + sectionId);
      this.panel = document.getElementById('fc-panel-' + sectionId);
      this.panelContent = document.getElementById('fc-panel-content-' + sectionId);
      const closeBtn = document.getElementById('fc-panel-close-' + sectionId);

// ── スワイプ処理（慣性スクロール版）────────────────
this._touchStartX = 0;
this._touchStartY = 0;
this._touchDeltaX = 0;
this._isSwiping = false;
this._touchStartTime = 0;
const SWIPE_THRESHOLD = 10;

const onTouchStart = (e) => {
  this._touchStartX = e.touches[0].clientX;
  this._touchStartY = e.touches[0].clientY;
  this._touchDeltaX = 0;
  this._isSwiping = false;
  this._touchStartTime = Date.now();

  // 慣性アニメーションを止める
  this.track.style.transition = 'none';
  const currentOffset = this.currentIndex * -this.getItemWidth();
  this._dragBaseOffset = currentOffset;
};

const onTouchMove = (e) => {
  const dx = e.touches[0].clientX - this._touchStartX;
  const dy = e.touches[0].clientY - this._touchStartY;
  this._touchDeltaX = dx;

  if (Math.abs(dx) > Math.abs(dy)) {
    e.preventDefault();
    this._isSwiping = true;

    // 指に追従してトラックを動かす（端は少し抵抗をかける）
    const maxOffset = 0;
    const minOffset = this.maxIndex() * -this.getItemWidth();
    let newOffset = this._dragBaseOffset + dx;

    // 端を超えた場合は抵抗（ゴム感）
    if (newOffset > maxOffset) {
      newOffset = maxOffset + (newOffset - maxOffset) * 0.3;
    } else if (newOffset < minOffset) {
      newOffset = minOffset + (newOffset - minOffset) * 0.3;
    }

    this.track.style.transform = `translateX(${newOffset}px)`;
  }
};

const onTouchEnd = (e) => {
  if (!this._isSwiping) return;

  const elapsed = Date.now() - this._touchStartTime;
  const velocity = this._touchDeltaX / elapsed; // px/ms
  const itemWidth = this.getItemWidth();

  // 慣性で何枚動かすか計算（速度 × 係数）
  const velocitySlides = Math.round(Math.abs(velocity) * 300 / itemWidth);
  // 距離ベースでも何枚か計算
  const distanceSlides = Math.round(Math.abs(this._touchDeltaX) / itemWidth);
  // 多い方を採用（最低1枚、最大3枚）
  const slidesToMove = Math.min(3, Math.max(
    this._touchDeltaX !== 0 ? 1 : 0,
    velocitySlides,
    distanceSlides
  ));

  // トランジションを戻す
  this.track.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  if (Math.abs(this._touchDeltaX) >= SWIPE_THRESHOLD && slidesToMove > 0) {
    if (this._touchDeltaX < 0) {
      this.currentIndex = Math.min(this.currentIndex + slidesToMove, this.maxIndex());
    } else {
      this.currentIndex = Math.max(this.currentIndex - slidesToMove, 0);
    }
    e.preventDefault();
  }

  this.setPosition();
  this.updateButtons();
};

const window_ = this.querySelector('.featured-carousel-window') || this.track;
window_.addEventListener('touchstart', onTouchStart, { passive: true });
window_.addEventListener('touchmove', onTouchMove, { passive: false });
window_.addEventListener('touchend', onTouchEnd);
// ─────────────────────────────────────────────


      // 商品カードクリックでパネルを開く
      this.items.forEach(item => {
        item.addEventListener('click', (e) => {
          // スワイプ後はパネルを開かない
          if (Math.abs(this._touchDeltaX) >= SWIPE_THRESHOLD) return;
          // ホバー状態でない場合はホバーを付与してパネルは開かない（スマホのみ）
          if ('ontouchstart' in window && !item.classList.contains('is-touch-hover')) {
  this.items.forEach(i => i.classList.remove('is-touch-hover'));
  item.classList.add('is-touch-hover');
  e.preventDefault();
  e.stopPropagation();
  return;
}



          const link = item.querySelector('a.card__heading-link, a[href*="/products/"]');
          e.preventDefault();
          e.stopPropagation();

          const img = item.querySelector('img');
          const title = item.querySelector('.card__heading')?.textContent?.trim() || '';
          const price = item.querySelector('.price-item')?.textContent?.trim() || '';
          const url = link?.href || '#';
          const imgSrc = img?.src || '';

          if (this.panelContent) {
            this.panelContent.innerHTML = `
              ${imgSrc ? `<img src="${imgSrc}" alt="${title}">` : ''}
              <h3 class="fc-panel__title">${title}</h3>
              <div class="fc-panel__price">${price}</div>
              <a href="${url}" class="fc-panel__link">商品ページへ</a>
            `;
          }
          if (this.panel) this.panel.classList.add('active');
          if (this.overlay) this.overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      });

      // 閉じる
      const closePanel = () => {
        if (this.panel) this.panel.classList.remove('active');
        if (this.overlay) this.overlay.classList.remove('active');
        document.body.style.overflow = '';
      };
      if (closeBtn) closeBtn.addEventListener('click', closePanel);
      if (this.overlay) this.overlay.addEventListener('click', closePanel);
    }

    updateItemsPerView() {
      const desktop = parseInt(this.dataset.desktopItems) || 4;
      const mobile = parseInt(this.dataset.mobileItems) || 2;
      this.itemsPerView = window.innerWidth <= 749 ? mobile : desktop;
    }

    maxIndex() {
      return Math.max(0, this.items.length - this.itemsPerView);
    }

    getItemWidth() {
      const item = this.items[0];
      const trackStyle = window.getComputedStyle(this.track);
      this.gap = parseFloat(trackStyle.gap) || 16;
      const itemWidth = item.getBoundingClientRect().width;
      return itemWidth + this.gap;
    }

    setPosition() {
      const offset = this.currentIndex * -this.getItemWidth();
      this.track.style.transform = `translateX(${offset}px)`;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.setPosition();
        this.updateButtons();
      }
    }

    next() {
      if (this.currentIndex < this.maxIndex()) {
        this.currentIndex++;
        this.setPosition();
        this.updateButtons();
      }
    }

    updateButtons() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex();
    }
  }

  if (!customElements.get('featured-carousel')) {
    customElements.define('featured-carousel', FeaturedCarousel);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
